// extracted by mini-css-extract-plugin
export var breedNavWrap = "breedNav-module--breedNavWrap--375ed";
export var footerBreedNav = "breedNav-module--footerBreedNav--408c4";